import UnderOverTable from "./UnderOverTable";
import {OddEvenTable} from "./OddEvenTable";
import React from "react";

const History = (props) => {
    const {statistic: {underOverItems, numberItems}, t} = props;

    return <div className="bet-history-wrap">
        <div className="history-under-over">
            <UnderOverTable underOverItems={underOverItems} t={t}/>
        </div>
        <div className="history-odd-even">
            <OddEvenTable numberItems={numberItems} t={t}/>
        </div>
    </div>
}

export default History